import tw, { styled } from 'twin.macro'
import { BaseInterText } from './styledComponents'

const Text7XlLeadingNone = styled(BaseInterText)`
   /* FIXME: USING INSTEAD OF text-7xl */
   ${tw`text-72px leading-none`}
`
const Text6XlLeadingNone = styled(BaseInterText)`
   /* FIXME: USING INSTEAD OF text-6xl */
   ${tw`text-60px leading-none`}
`

const Text5XlLeadingNone = styled(BaseInterText)`
   /* FIXME: USING INSTEAD OF text-5xl */
   ${tw`text-48px leading-none`}
`

const Text4xlLeading10 = styled(BaseInterText)`
   /* FIXME: USING INSTEAD OF text-4xl */
   ${tw`text-36px leading-10`}
`

const Text3xlLeading9 = styled(BaseInterText)`
   /* FIXME: USING INSTEAD OF text-3xl */
   ${tw`text-30px leading-9`}
`

const Text2xlLeading8 = styled(BaseInterText)`
   /* FIXME: USING INSTEAD OF text-2xl */
   ${tw`text-24px leading-8`}
`

const TextXlLeading7 = styled(BaseInterText)`
   /* FIXME: USING INSTEAD OF text-xl */
   ${tw`text-20px leading-7`}
`

const TextXsLeading7 = styled(BaseInterText)`
   /* FIXME: USING INSTEAD OF text-xs */
   ${tw`text-12px leading-7`}
`

const TextLgLeading7 = styled(BaseInterText)`
   ${tw`text-lg leading-7`}
`

const TextBaseLeading6 = styled(BaseInterText)`
   ${tw`text-base leading-6`}
`

const TextSmLeading5 = styled(BaseInterText)`
   ${tw`text-sm leading-5`}
`

const TextSmLeading4 = styled(BaseInterText)`
   ${tw`text-sm leading-4`}
`

const TextXsLeading4 = styled(BaseInterText)`
   ${tw`text-xs leading-4`}
`
export const TextXsAllCaps = styled(BaseInterText)`
   ${tw`text-xs uppercase tracking-4%`}
`

// NOTE: ReadyMade Typos

export const Text7XlLeadingNoneFontBold = styled(Text7XlLeadingNone)`
   ${tw`font-bold`}
`

export const Text6XlLeadingNoneFontSemibold = styled(Text6XlLeadingNone)`
   ${tw`font-semibold`}
`

export const Text5XlLeadingNoneFontBold = styled(Text5XlLeadingNone)`
   ${tw`font-bold`}
`

export const Text4xlLeading10FontSemibold = styled(Text4xlLeading10)`
   ${tw`font-semibold`}
`

export const Text3xlLeading9FontBold = styled(Text3xlLeading9)`
   ${tw`font-bold`}
`
export const Text3xlLeading9FontSemibold = styled(Text3xlLeading9)`
   ${tw`font-semibold`}
`

export const Text2xlLeading8FontSemibold = styled(Text2xlLeading8)`
   ${tw`font-semibold`}
`
export const Text2xlLeading8FontBold = styled(Text2xlLeading8)`
   ${tw`font-bold`}
`

export const TextXlLeading7FontSemibold = styled(TextXlLeading7)`
   ${tw`font-semibold`}
`
export const TextXlLeading7FontMedium = styled(TextXlLeading7)`
   ${tw`font-medium`}
`

export const TextLgLeading7Semibold = styled(TextLgLeading7)`
   ${tw`font-semibold`}
`

export const TextLgLeading7FontMedium = styled(TextLgLeading7)`
   ${tw`font-medium`}
`
export const TextLgLeading7FontBold = styled(TextLgLeading7)`
   ${tw`font-bold`}
`

export const TextLgLeading7FontNormal = styled(TextXlLeading7)`
   ${tw`font-normal`}
`

export const TextBaseLeading6FontMedium = styled(TextBaseLeading6)`
   ${tw`font-medium`}
`
export const TextBaseLeading6FontBold = styled(TextBaseLeading6)`
   ${tw`font-bold`}
`
export const TextBaseLeading6FontSemiBold = styled(TextBaseLeading6)`
   ${tw`font-semibold`}
`
export const TextBaseLeading6FontExtraBold = styled(TextBaseLeading6)`
   ${tw`font-extrabold`}
`

export const TextSmLeading5FontMedium = styled(TextSmLeading5)`
   ${tw`font-medium`}
`

export const TextSmLeading4FontMedium = styled(TextSmLeading4)`
   ${tw`font-medium`}
`

export const TextSmLeading4FontNormal = styled(TextSmLeading4)`
   ${tw`font-normal`}
`

export const TextBaseLeading6FontNormal = styled(TextBaseLeading6)`
   ${tw`font-normal`}
`

export const TextSmLeading5FontNormal = styled(TextSmLeading5)`
   ${tw`font-normal`}
`

export const TextXsLeading4FontNormal = styled(TextXsLeading4)`
   ${tw`font-normal`}
`

export const TextXsLeading4FontMedium = styled(TextXsLeading4)`
   ${tw`font-medium`}
`
export const TextXsLeading4FontSemiBold = styled(TextXsLeading4)`
   ${tw`font-semibold`}
`

export const TextXsAllCapsSemiBold = styled(TextXsAllCaps)`
   ${tw`font-semibold`}
`

export const TextSmLeading5FontBold = styled(TextSmLeading5)`
   ${tw`font-bold`}
`

export const TextSmLeading5FontSemiBold = styled(TextSmLeading5)`
   ${tw`font-semibold`}
`

export const TextXlLeading7FontBold = styled(TextXlLeading7)`
   ${tw`font-bold`}
`

export const TextXsLeading7FontBold = styled(TextXsLeading7)`
   ${tw`font-bold`}
`

export const TextSmLeading5FontRegular = styled(TextSmLeading5)``
